import type { ScreenModule } from "../../../app/screen-module";
import { AnalyticsPage } from "../pages";

export default {
	id: "system-admin.analytics",
	path: "/system/analytics",
	area: "system-admin",
	navGroup: "製品",
	label: "分析",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: AnalyticsPage,
} satisfies ScreenModule;
